import { useField } from "formik";
import CheckboxGroupNodeType from "../../types/CheckboxGroupNodeType";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import normalizeOptions from "./normalizeOptions";
import renderChildren from "../renderChildren";

export const CheckboxGroup = ({
                                name,
                                options = [],
                                inline,
                                row,
                                gap,
                                sx,
                                itemSx,
                                labelSx,
                                node,
                                context,
                              }: CheckboxGroupNodeType & any) => {
  const [field, , helpers] = useField(name);

  const values = field.value || [];
  const items = normalizeOptions(options);
  const hasCustomTemplate = Boolean(node?.children?.length);

  const toggleValue = (value: any) => {
    if (values.includes(value)) {
      helpers.setValue(values.filter((v) => v !== value));
    } else {
      helpers.setValue([...values, value]);
    }
  };

  return (
      <FormGroup
          row={row ?? inline}
          sx={{
            ...(gap !== undefined ? { gap } : {}),
            ...sx,
          }}
      >
        {items.map((opt, index) => {
          const item = { ...opt };
          const checked = values.includes(opt.value);
          const itemContext = {
            ...(context || {}),
            item,
            option: item,
            index,
            isSelected: checked,
            checked,
          };

          return (
            <FormControlLabel
                key={opt.value}
                sx={itemSx}
                control={
                  <Checkbox
                      checked={checked}
                      onChange={() => toggleValue(opt.value)}
                  />
                }
                label={
                  hasCustomTemplate
                    ? renderChildren(node.children, itemContext)
                    : opt.label ?? opt.value
                }
                slotProps={{
                  typography: {
                    sx: labelSx,
                  },
                }}
            />
          );
        })}
      </FormGroup>
  );
};

export default CheckboxGroup;
